import { PreloadingStrategy, Route } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of'; // for Observable.of()

@Injectable()
export class SelectivePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.path === 'imi-arabian-default') {
      return load(); 
    }
    return Observable.of(null); 
}
 }


// WEBPACK FOOTER //
// /app/src/app/selective-preload.strategy.ts